import styled from 'styled-components';

const MicroModulatingBurnerWrapper = styled.div``;

export { MicroModulatingBurnerWrapper };
